import { messages as ptMessages } from './pt';
import { messages as enMessages } from './en';

const messages = {
  ...ptMessages,
  ...enMessages,
};

export { messages };
